<template>
  <div class="mt-10">
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Share widget
          </h3>
          <div>
            <WhatsappShareButton :config="config" />
          </div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
          <form @submit="handleSubmit">
            <fieldset class="mt-6">
              <legend class="text-base leading-6 font-medium text-gray-900">
                Position
              </legend>

              <div class="mt-4 flex flex-wrap">
                <div
                  class="flex items-center m-2"
                  v-for="(position, index) in supportedPosition"
                  :key="index"
                >
                  <input
                    :id="`radio_share_${position.value}`"
                    type="radio"
                    class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                    v-model="config.shareButton.position"
                    :value="position.value"
                  />
                  <label :for="`radio_share_${position.value}`" class="ml-3">
                    <span
                      class="block text-sm leading-5 font-medium text-gray-700"
                      >{{ position.label }}
                    </span>
                  </label>
                </div>
              </div>
            </fieldset>
            <fieldset class="mt-6">
              <legend class="text-base leading-6 font-medium text-gray-900">
                Design
              </legend>

              <div class="mt-4 flex flex-wrap">
                <div
                  class="flex items-center m-2"
                  v-for="(design, index) in supportedDesign"
                  :key="index"
                >
                  <input
                    :id="`radio_share_design_${design.value}`"
                    type="radio"
                    class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                    v-model="config.shareButton.design"
                    :value="design.value"
                  />
                  <label
                    :for="`radio_share_design_${design.value}`"
                    class="ml-3"
                  >
                    <span
                      class="block text-sm leading-5 font-medium text-gray-700"
                      >{{ design.label }}
                    </span>
                  </label>
                </div>
              </div>
            </fieldset>
            <div class="mt-6">
              <div class="rounded-md ">
                <div class="grid grid-cols-6 gap-6">
                  <div class="col-span-6 sm:col-span-6 lg:col-span-2 relative">
                    <label
                      for="city"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Button Background
                    </label>

                    <input
                      class="mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      v-model="config.shareButton.colors.buttonBackgroundColor"
                    />
                    <verte
                      picker="square"
                      v-model="config.shareButton.colors.buttonBackgroundColor"
                      class="colorPicker"
                      model="hex"
                    ></verte>
                  </div>
                  <div class="col-span-6 sm:col-span-6 lg:col-span-2 relative">
                    <label
                      for="city"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Button Text Color</label
                    >

                    <input
                      class="mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      v-model="config.shareButton.colors.buttonTextColor"
                    />
                    <verte
                      picker="square"
                      v-model="config.shareButton.colors.buttonTextColor"
                      class="colorPicker"
                      model="hex"
                    ></verte>
                  </div>
                  <div class="col-span-6 sm:col-span-6 lg:col-span-2 relative">
                    <label
                      for="city"
                      class="block text-sm font-medium leading-5 text-gray-700"
                      >Button Icon Color</label
                    >
                    <input
                      class="mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      v-model="config.shareButton.colors.buttonIconColor"
                    />
                    <verte
                      v-model="config.shareButton.colors.buttonIconColor"
                      class="colorPicker"
                      picker="square"
                      model="hex"
                    ></verte>
                  </div>
                </div>
              </div>
              <div class="mt-6">
                <div class="rounded-md shadow-sm">
                  <div class="grid grid-cols-6 gap-6">
                    <div
                      class="col-span-6 sm:col-span-6 lg:col-span-2 relative"
                    >
                      <label
                        for="city"
                        class="block text-sm font-medium leading-5 text-gray-700"
                        >Button Label</label
                      >

                      <input
                        class="mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        v-model="config.shareButton.label"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-8 border-t border-gray-200 pt-5">
                <div class="flex justify-end">
                  <span class="ml-3 inline-flex rounded-md shadow-sm">
                    <button
                      class="Polaris-Button Polaris-Button--primary"
                      type="submit"
                      @click="$emit('save')"
                    >
                      <span class="Polaris-Button__Content">
                        <span class="Polaris-Button__Text">Save</span>
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verte from "verte";
import "verte/dist/verte.css";

import WhatsappShareButton from "./WhatsappShareButton";

export default {
  name: "ShareConfigureForm",
  components: {
    Verte,
    WhatsappShareButton
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      phoneNumber: "",
      defaultTemplate: "",
      supportedPosition: [
        {
          label: "Left",
          value: "left"
        },
        {
          label: "Right",
          value: "right"
        }
      ],
      supportedDesign: [
        {
          label: "Button With Text and Icon",
          value: "buttonWithTextIcon"
        },
        {
          label: "Button With Icon",
          value: "buttonWithIcon"
        }
      ]
    };
  },
  mounted() {
    this.phoneNumber = this.config.phoneNumber;
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, { number, isValid, country }) {
      console.log(number, isValid, country);
      if (isValid) {
        this.config.phoneNumber = number.e164;
      }
    },
    init() {
      this.$store.dispatch("getChatConfig");
    }
  }
};
</script>

<style lang="scss">
.colorPicker {
  position: absolute !important;
  top: 30px;
  left: 8px;
}
</style>
